import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { ReactiveFormsModule } from '@angular/forms';
import { AddressService } from './address.service';
import { AddressComponent } from './address.component';
import { InputSelectModule } from '../input/input-select/input-select.module';

@NgModule(
    {
        declarations: [
            AddressComponent
        ],
        imports: [
            CommonModule,
            InputSelectModule,
            ReactiveFormsModule
        ],
        exports: [
            CommonModule,
            InputSelectModule,
            AddressComponent
        ],
        providers: [
            AddressService
        ]
    }
)
export class AddressModule { }
